import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import styles from "./Drawer.module.css";

export default function Drawer({
  open = false,
  onClose,
  children
}) {
  const [visible, setVisible] = useState(open);
  const drawerRef = useRef(null);
  const location = useLocation();

  const startX = useRef(0);
  const currentX = useRef(0);
  const dragging = useRef(false);

  useEffect(() => {
    if (open) {
      setVisible(true);
    } else {
      setVisible(false);
    }
  }, [open]);

  useEffect(() => {
    if (open) {
      setVisible(false);
      onClose && onClose();
    }
  }, [location.pathname]);

  if (!visible) return null;

  const handleOverlayClick = () => {
    setVisible(false);
    onClose && onClose();
  };

  const handleTouchStart = (e) => {
    dragging.current = true;
    startX.current = e.touches[0].clientX;
    currentX.current = e.touches[0].clientX;
  };

  const handleTouchMove = (e) => {
    if (!dragging.current) return;

    currentX.current = e.touches[0].clientX;
    const delta = currentX.current - startX.current;

    if (delta < 0 && drawerRef.current) {
      drawerRef.current.style.transform = `translateX(${delta}px)`;
    }
  };

  const handleTouchEnd = () => {
    if (!dragging.current) return;

    dragging.current = false;

    const delta = currentX.current - startX.current;

    if (delta < -80) {
      handleOverlayClick();
    } else if (drawerRef.current) {
      drawerRef.current.style.transform = "translateX(0)";
    }
  };

  return (
    <>
      <div
        className={styles.overlay}
        onClick={handleOverlayClick}
      />

      <aside
        ref={drawerRef}
        className={`${styles.drawer} ${!open ? styles.drawerClosing : ""}`}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        {children}
      </aside>
    </>
  );
}